





























import { Component, Prop, Vue } from 'vue-property-decorator'

import { ModalState } from '@/models'

@Component
export default class UpdateImageModal extends Vue {
  @Prop({ type: ModalState, required: true })
  readonly modalState!: ModalState

  imageFile: File | null = null

  get isValid () {
    return this.imageFile !== null
  }

  changeImageFile (_: string, files: File[]) {
    this.imageFile = files[0]
  }

  clear () {
    this.imageFile = null
  }

  cancel () {
    this.modalState.reset()

    this.clear()

    this.$emit('cancel')
  }

  submit () {
    if (!this.isValid) {
      return
    }

    this.$emit('submit', this.imageFile)
    this.clear()
  }
}
